import { cn } from '@utils/cn';
import { AvatarMarble } from './AvatarMarble';
import { Skeleton } from '@components/Skeleton';
import { Img, type ImgProps } from 'react-image';

export type AvatarProps = ImgProps & {
  isLoading?: boolean;
  name?: string;
};

export const Avatar = ({
  alt = 'Avatar',
  name,
  className,
  isLoading,
  ...props
}: AvatarProps) => {
  if (isLoading) {
    return <Skeleton className={className} />;
  }

  return (
    <Img
      alt={alt}
      loader={<Skeleton className={className} />}
      unloader={<AvatarMarble name={name} className={className} />}
      className={cn(
        'bg-elz-neutral-6 aspect-1 object-cover object-center',
        className,
      )}
      {...props}
    />
  );
};
